const ClientBookedAppointmentsIcon = ({ fillColor = '#000' }: { fillColor: string }) => {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.25" y="5" width="13.5" height="11.25" rx="2" stroke={fillColor} />
      <path d="M3 8.75H15" stroke={fillColor} strokeLinecap="round" />
      <path d="M6.75 12.5H11.25" stroke={fillColor} strokeLinecap="round" />
      <path d="M6 2.75L6 5.75" stroke={fillColor} strokeLinecap="round" />
      <path d="M12 2.75L12 5.75" stroke={fillColor} strokeLinecap="round" />
    </svg>
  );
};

export default ClientBookedAppointmentsIcon;
